/**
 * DBから取得したタイムスタンプをyyyy/mm/ddに変換する
 * @param {number} timestamp タイムスタンプ - Should be in milliseconds.
 * @returns {String}
 */
const changeToYYYYMMDD = function (timestamp: number) {
  // const date = new Date(timestamp * 1000); //Timestamp in seconds (e.g., 1749119976)
  const date = new Date(timestamp); //Timestamp in milliseconds (e.g., 1749119976965)
  const yyyy = `${date.getFullYear()}`;
  // sliceすることで0埋めをする
  const mm = `0${date.getMonth() + 1}`.slice(-2);
  const dd = `0${date.getDate()}`.slice(-2);

  return `${yyyy}/${mm}/${dd}`;
};

export default {
  changeToYYYYMMDD,
};
